export const scrollProgress = () => {
	const measureScrollProgressElements = (nodeList) => {
		if (nodeList.length) {
			const elementHeights = Array.from(nodeList).map((el) => {
				const computedStyles = window.getComputedStyle(el);
				return (
					el.getBoundingClientRect().height +
					parseInt(computedStyles.getPropertyValue("margin-top"), 10) +
					parseInt(computedStyles.getPropertyValue("margin-bottom"), 10)
				);
			});
			return elementHeights.reduce((previous, current) => previous + current, 0);
		} else {
			return 0;
		}
	};

	let progressElementHeights = {
		scrollAreaHt: document.querySelector(".content-page").getBoundingClientRect().height || 0,
		disclaimerElHt: measureScrollProgressElements(
			document.querySelectorAll(".content-page-disclaimer") || 0
		),
		footnoteElHt:
			measureScrollProgressElements(document.querySelectorAll(".content-page-footnotes")) || 0,
	};

	const setScrollProgress = () => {
		const excludedElHt =
			progressElementHeights.footnoteElHt + progressElementHeights.disclaimerElHt;
		const height = progressElementHeights.scrollAreaHt - excludedElHt - window.innerHeight;
		const scrollPos = window.scrollY;
		const progressValue = (scrollPos * 100) / height;
		const progressBarEl = document.getElementById("scroll-progress-bar");

		if (progressValue && progressValue >= 0 && progressBarEl) {
			progressBarEl.value = progressValue;
		}
	};

	const init = () => {
		progressElementHeights = {
			scrollAreaHt: document.querySelector(".content-page").getBoundingClientRect().height,
			disclaimerElHt: measureScrollProgressElements(
				document.querySelectorAll(".content-page-disclaimer")
			),
			footnoteElHt: measureScrollProgressElements(
				document.querySelectorAll(".content-page-footnotes")
			),
		};

		setScrollProgress();
	};

	const resizeObserver = new ResizeObserver((entries) => {
		window.requestAnimationFrame(() => {
			if (!Array.isArray(entries) || !entries.length) {
				return;
			}
			init();
		});
	});
	resizeObserver.observe(document.querySelector(".content-page"));
	window.addEventListener("scroll", setScrollProgress);
	window.addEventListener("resize", setScrollProgress);
};
